<template>
    <div class="w-full flex flex-column">
        <div class="w-full flex surface-200 overflow-hidden border-round-xl relative" 
            :style="(screen_size!='xs' && screen_size!='sm') ? 'padding-bottom:56%;' : 'padding-bottom:100%;'">
            <div class="absolute" style="top:0;left:0;right:0;bottom:0">
                <div v-if="!file" class="w-full h-full">
                    <camera v-if="screen_size" :resolution="(screen_size!='xs' && screen_size!='sm') ? horisontal : vertical" ref="camera" autoplay></camera>
                </div>
                <div v-if="file" class="w-full h-full overflow-hidden border-round-xl">
                    <img v-if="url" :src="url" class="w-full h-full">
                </div>
            </div>
            <Skeleton class="absolute" v-if="!devices" style="height:100%"/>
        </div>
        <div class="flex flex-row justify-content-center my-3">
            <Button icon="pi pi-camera" class="mx-3 p-button-lg border-circle" @click="snapshot" :disabled="url" style="height:50px;width: 50px;"/>
            <Button icon="pi pi-sync" class="mx-3 p-button-lg border-circle" @click="changeCamera" :disabled="url" style="height:50px;width: 50px;"/>
            <Button icon="pi pi-times" class="mx-3 p-button-lg border-circle" @click="reset" :disabled="!url" style="height:50px;width: 50px;"/>
        </div>
    </div>

</template>

<script>
import Connect from '@/assets/js/Connect'
import Camera from "simple-vue-camera";
import { defineComponent, ref } from "vue";

export default {
    name: 'screenCamera',
    props: ['screen_size'],
    data() {
        return {
            file: null,
            url: null,
            devices: [],
            horisontal: { width: 1920, height: 1080 },
            vertical: { width: 1080, height: 1080 },
            content: {
                ru: {
					success: 'Успешно',
					error: 'Ошибка',
					file_uploaded: 'Файл загружен',
					maximum_files: 'Максимальное количество файлов 3'
				},
				en: {
					success: 'Success',
					error: 'Error',
					file_uploaded: 'File uploaded',
					maximum_files: 'Maximum files 3'
				}
			},
        }
    },
    setup(props, { emit }) {
        const camera = ref(null);

        const cameraIsOn = ref(false);

        const cameraOff = () => {
            cameraIsOn.value ? camera.value.stop() : camera.value.start();
            cameraIsOn.value = !cameraIsOn.value;
        };

        const startCamera = async () => {
            await camera.value?.start()
        };

        const takePicture = async () => {
            const resolution = (props.screen_size!='xs' && props.screen_size!='sm') ? { width: 1920, height: 1080 } : { width: 1080, height: 1080 }
            const imageBlob = await camera.value.snapshot(resolution, "image/png", 1)
            const url = URL.createObjectURL(imageBlob)
            const file = new File([imageBlob], "image.png", { type: "image/png" })
            return {result: true, blob: imageBlob, url: url, file: file}
        };

        const emit_file = (file) => {   
            emit('onUpload', file)
        };

        const changeCamera = async () => {
            const deviceId = await getNextDevice().then(res => res.deviceId)
            if(deviceId) camera.value?.changeCamera(deviceId)
            else alert('No camera found')
        };

        
        const getNextDevice = async () => {
            const devices = await getAllDevices().then(res => res)
            if(!devices) return
            const currentDeviceId = camera.value?.currentDeviceID()
            const currentIndex = devices.findIndex(device => device.deviceId === currentDeviceId)
            const nextDevice = (currentIndex+1 < devices.length) ? devices[currentIndex+1] : devices[0]
            return nextDevice
        };

        const getAllDevices = async () => {
            const devices = await camera.value?.devices(["videoinput"]);
            return devices
        };


        return {
            camera,
            startCamera,
            cameraOff,
            cameraIsOn,
            takePicture,
            emit_file,
            changeCamera,
            getAllDevices
        };
    },
    methods: {
        async snapshot  (){ 
            const picture = await this.takePicture().then(res => res)
            if(picture.result){
                this.url = picture.url
                this.file = picture.file
                this.$emit('onUpload', picture.file)
            } else {
                this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].error)
            }
        },
        async reset() {
            this.file = null
            this.url = null
            this.$emit('onReset', true)
            await this.startCamera()
        },
        saveData (blob) {
            var a = document.createElement("a");
            document.body.appendChild(a);
            var url = window.URL.createObjectURL(blob);

            a.href = url;
            a.download = 'image.png';
            a.click();
            window.URL.revokeObjectURL(url);
            return 
        },
        async onAdvancedUpload(event) {
			const files = [this.file]
			if (files.length <= 0) return
			if (files.length > 3) {
				this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].maximum_files)
				return
			}
			const formData = new FormData()

			for (let i = 0; i < files.length; i++) {
				formData.append("files", files[i], files[i].name)
			}

			const upload = await this.connect.sendFiles(formData).then(res => res)
			if (upload.result && upload.data) {
				this.showMess('success', this.content[this.lang_].success, this.content[this.lang_].file_uploaded)
			} else {
				if(upload.errors && deals.errors.length > 0 ){
                    for (let i = 0; i < deals.errors.length; i++) {
                        this.showMess('error', this.content[this.lang_].error, deals.errors[i])
                    }
                }
			}
		},
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
        },
    },
    watch: {
        file() {

        }
    },
    components: {
        Camera
    },
    async beforeCreate() {
        this.connect = new Connect()
    },
    async mounted() {
        const devices = await this.getAllDevices().then(res => res)
        this.devices = devices
    },
}
</script>
